import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
export const RecentOrderGiftListItemLoading = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex w-[22rem] items-center gap-20", "mobile-tablet:w-[20.9375rem] mobile-tablet:justify-start mobile-tablet:gap-16 mobile-tablet:pr-32");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className={cn("size-140 rounded-xlarge object-cover", "mobile-tablet:size-104")} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li className={t0}>{t1}<div className="flex grow flex-col gap-4"><div className="flex items-center gap-4"><Skeleton className={cn("size-24 shrink-0 rounded-pill", "mobile-tablet:size-20")} /><Skeleton typo="body4" className="w-1/2 rounded-xxsmall" /></div><Skeleton typo="body3" className="mt-2 w-full rounded-xxsmall" /><Skeleton typo="body3" className="w-2/3 rounded-xxsmall" /><Skeleton typo="body4" className="w-1/3 rounded-xxsmall" /></div></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};